import { useTranslation } from "react-i18next";
import { WithAuthorization } from "../../context";
import { Page } from "../../components/Page";
import { Card } from "../../components/Card";
import { Center, Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import { useState } from "react";
import { TopTenSuppliersTab } from "./components/TopTenSuppliersTab";
import { SpecificSupplierTab } from "./components/SpecificSupplierTab";
import { TotalEmissionsTab } from "./components/TotalEmissionsTab";
import { SupplierTiers } from "./components/SupplierTiers";
import { EmissionsByYearTab } from "./components/EmissionsByYearTab";
import { EmissionsGraphTab } from "./components/EmissionsGraphTab";
import { CarbonIntensityTab } from "./components/CarbonIntensityTab";

function SuppliersEmissionsDashboard() {
  const { t } = useTranslation("translation", {
    keyPrefix: "suppliersEmissionsDashboard",
  });

  const [tabIndex, setTabIndex] = useState(0);
  const [selectedYear, setSelectedYear] = useState((new Date().getFullYear() - 1).toString());

  return (
    <Page title={t("page.title")} subTitle={t("page.subTitle")}>
      <Card>
        <Tabs colorScheme="customScheme" index={tabIndex} onChange={setTabIndex} isLazy>
          <Center>
            <TabList borderBottom="none" overflow="auto">
              <Tab mb={0} _focus={{ boxShadow: "none" }}>
                {t("tabs.totalEmissions")}
              </Tab>
              <Tab mb={0} _focus={{ boxShadow: "none" }}>
                {t("tabs.emissionsByYear")}
              </Tab>
              {/*<Tab mb={0} _focus={{ boxShadow: "none" }}>*/}
              {/*  {t("tabs.specificSupplier")}*/}
              {/*</Tab>*/}
              {/*<Tab mb={0} _focus={{ boxShadow: "none" }}>*/}
              {/*  {t("tabs.topTen")}*/}
              {/*</Tab>*/}
              <Tab mb={0} _focus={{ boxShadow: "none" }}>
                {t("tabs.emissionsGraph")}
              </Tab>
              <Tab mb={0} _focus={{ boxShadow: "none" }}>
                {t("tabs.carbonIntensity")}
              </Tab>
              <Tab mb={0} _focus={{ boxShadow: "none" }}>
                {t("tabs.supplierTiers")}
              </Tab>
            </TabList>
          </Center>
          <TabPanels>
            <TabPanel padding="0">
              <TotalEmissionsTab selectedYear={selectedYear} setSelectedYear={setSelectedYear} />
            </TabPanel>
            <TabPanel padding="0">
              <EmissionsByYearTab />
            </TabPanel>
            {/*<TabPanel padding="0">*/}
            {/*  <SpecificSupplierTab selectedYear={selectedYear} setSelectedYear={setSelectedYear} />*/}
            {/*</TabPanel>*/}
            {/*<TabPanel padding="0">*/}
            {/*  <TopTenSuppliersTab selectedYear={selectedYear} setSelectedYear={setSelectedYear} />*/}
            {/*</TabPanel>*/}
            <TabPanel padding="0">
              <EmissionsGraphTab />
            </TabPanel>
            <TabPanel padding="0">
              <CarbonIntensityTab />
            </TabPanel>
            <TabPanel padding="0">
              <SupplierTiers selectedYear={selectedYear} setSelectedYear={setSelectedYear} />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Card>
    </Page>
  );
}

export default WithAuthorization(SuppliersEmissionsDashboard);
